// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"styles_ButtonContainer__EBppx","Button":"styles_Button__Rzkci"};